jQuery( document ).ready(function($) { 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '991',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });
  //Check Width
	$(checkWidth);
	$(window).resize(function() {
    checkWidth();
  });
  
	function checkWidth() {
		var windowsize = $(window).width();
		
    if (windowsize < 1200) {
      // hide search on larger screens
      $('#collapse-search').collapse('hide');
    }
	}
});